import { InfoBadge } from './InfoBadge';

export default InfoBadge;
